import { useEffect, useRef, useState } from 'react';
import { getJobProfiles } from './services';
import { useSessionStorage } from 'hooks/useSessionStorage';
import { verifyIsCompanyPermited } from 'utils/checkFunctionalityPermission';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@welbe/web-design-system';

export interface IItems {
	id: string;
	name: string;
	description: string;
}

export const useListJobProfile = () => {
	const { toast } = useToast();
	const preventReRender = useRef(false);
	const { getSessionStorage } = useSessionStorage();
	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(true);
	const [risksProfile, setRisksProfile] = useState<IItems[]>([]);
	const [expositionAreas, setExpositionAreas] = useState<IItems[]>([]);
	const [hasError, setHasError] = useState<boolean>(false);
	const [isCompanyJobProfile, setIsCompanyJobProfile] = useState<
		boolean | undefined
	>(false);
	const [
		showModalJobProfileNotAuthorized,
		setShowModalJobProfileNotAuthorized,
	] = useState(false);

	const fetchJobProfile = async () => {
		try {
			setIsLoading(true);
			const { data } = await getJobProfiles();
			setRisksProfile(data?.content?.riskProfiles);
			setExpositionAreas(data?.content?.expositionAreas);
		} catch (error) {
			setHasError(true);
			toast.error('Error al cargar los perfiles de riesgo');
		} finally {
			setIsLoading(false);
		}
	};

	const handleCloseModalJobProfileNotAuthorized = () => {
		setShowModalJobProfileNotAuthorized(false);
	};

	const handleNewJobProfile = (jobProfileType: JobProfileType) => {
		if (isCompanyJobProfile) {
			navigate(`/job-profile/profile/${jobProfileType}`);
			return;
		}
		setShowModalJobProfileNotAuthorized(true);
	};

	const handleEditJobProfile = (jobProfileType: JobProfileType, id: string) => {
		if (isCompanyJobProfile) {
			navigate(`/job-profile/summary/${jobProfileType}/${id}`);
			return;
		}
		setShowModalJobProfileNotAuthorized(true);
	};

	const getMeInfo = async () => {
		try {
			const meCompany = getSessionStorage('me');
			if (meCompany) {
				setIsCompanyJobProfile(
					verifyIsCompanyPermited(JSON.parse(meCompany).company, 'jobProfile'),
				);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		if (!preventReRender.current) {
			getMeInfo();
			fetchJobProfile();
			preventReRender.current = true;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		risksProfile,
		expositionAreas,
		hasError,
		isLoading,
		showModalJobProfileNotAuthorized,
		handleCloseModalJobProfileNotAuthorized,
		handleNewJobProfile,
		handleEditJobProfile,
	};
};
